// package 内所有helper/components/creator 的向外出口
import ViewFactory from '../packages/creator/'
import spBreadcrumb from '../packages/components/Breadcrumb/'
import formTpl from '../packages/components/FormTpl/'
import spHeader from '../packages/components/Header/'
import spMenu from '../packages/components/Menu/'
import spTabs from '../packages/components/Tabs/'
import constant from '../packages/constant'
import CollectionDescriptor from '../packages/helper/resource'
import * as schema from '../packages/helper/schema'
import * as fields from '../packages/helper/fields'
import Module from '../packages/helper/module'
import Api from '../packages/helper/api'

import I18n, { currentLocale, setLocale, setI18nData} from '../packages/helper/i18n/index'
import elementLocales from '../packages/helper/i18n/element-locales'

import ElementUI from 'element-ui'
import Icon from 'vue-awesome'
import 'normalize.css'

export {
  ViewFactory,
  spBreadcrumb,
  formTpl,
  spHeader,
  spMenu,
  spTabs,
  constant,
  CollectionDescriptor,
  schema,
  fields,
  Module,
  Api,
  I18n,
  setLocale,
  setI18nData
}

const components = {
  formTpl,
  spBreadcrumb,
  spHeader,
  spMenu,
  spTabs
}

const install = function(Vue, opts = {}) {
  Vue.use(I18n, opts);
  Vue.use(ElementUI, { locale: elementLocales[currentLocale] })
  for(let name in components) {
    Vue.component(name, components[name]);
  }

  Vue.component('icon', Icon)
};

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  components,
  ViewFactory,
  helper: {
    CollectionDescriptor,
    schema,
    fields,
    Module,
    Api
  },
  I18n,
  constant
};



// WEBPACK FOOTER //
// ./src/index.js